import api from '..'

export async function deleteFlow(slug: string): Promise<void> {
  await api.delete(`/flows/${slug}`)
}
